export const PLAYER_SPEED_PX_PER_SEC = 220;
export const PLAYER_START_POSITION = { x: 100, y: 100 } as const;
export const PLAYER_SIZE_PX = 24;
export const PLAYER_HALF_EXTENT_PX = PLAYER_SIZE_PX / 2;
